type localesKeys__MiniCv = {
  miniCv__responsibilities: string;
  miniCv__achievements: string;
  miniCv__noDetails: string;
  miniCv__close: string;
};

const ruLocale__MiniCv: localesKeys__MiniCv = {
  miniCv__responsibilities: "Обязанности",
  miniCv__achievements: "Чего удалось достичь",
  miniCv__noDetails: "Нет деталей.",
  miniCv__close: "Закрыть",
};

const enLocale__MiniCv: localesKeys__MiniCv = {
  miniCv__responsibilities: "Responsibilities",
  miniCv__achievements: "Key achievements",
  miniCv__noDetails: "No details.",
  miniCv__close: "Close",
};

export { ruLocale__MiniCv, enLocale__MiniCv };
export type { localesKeys__MiniCv };
